export default "__VITE_ASSET__CHAv9SUu__"